/** @jsxImportSource @emotion/react */

import React from 'react'
import Radio from '@mui/material/Radio'
import { grey, deepPurple } from '@mui/material/colors'

interface PropsType {
	className?: string
	value: string | number
	selectedValue: string | number
	onRadioChange?: (value: string | number) => void
	color?: string
}

export const Radiobutton = (props: PropsType) => {
	const [isChecked, setIsChecked] = React.useState<boolean>(false)

	React.useEffect(() => {
		setIsChecked(props.selectedValue === props.value)
	}, [props.selectedValue])

	const onRadioChange = () => {
		if (props.onRadioChange) {
			props.onRadioChange(props.value)
		}
	}

	return (
		<Radio
			className={props.className ?? ''}
			checked={isChecked}
			value={props.value}
			onChange={onRadioChange}
			css={{
				color: grey[300],

				'&.Mui-checked': {
					color: props.color ? props.color : deepPurple['A400'],
				},
			}}
		/>
	)
}
